// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_J-z","twoColumnImage":"aK-z"};